define('hp',[
  'jquery', 'views/search-form', 'anystretch'
], function($, SearchFormView){

  return function() {

    $(document).ready(function() {

      $('#hp-search-outer').anystretch(background_img);

      new SearchFormView({el: $('#hp-search'), mobile: $.isMobileSite()});

    });

  }

});
